import React from 'react'

const AkvilonGrayLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="140"
    height="42"
    viewBox="0 0 140 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30479_10282)">
      <mask
        id="mask0_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_30479_10282)">
        <path
          d="M21.866 25.742L13.6842 6.91942V6.87103C13.2057 5.75813 12.0574 4.93555 10.7655 4.93555H9.1866C9.13876 4.93555 9.04306 4.98393 9.04306 5.03232L0 25.742V25.7904C0 25.8388 0.0478469 25.8872 0.0956938 25.8872H3.82775C3.8756 25.8872 3.97129 25.8388 3.97129 25.7904L6.02871 21.0968H13.7321C13.7321 19.3065 12.2966 17.8549 10.5263 17.8549H7.41627L10.8612 9.53232L14.6411 18.6291L17.7512 25.7904C17.799 25.8388 17.8469 25.8872 17.8947 25.8872H21.6746C21.8182 25.9355 21.866 25.8872 21.866 25.742C21.866 25.7904 21.866 25.7904 21.866 25.742Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask1_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_30479_10282)">
        <path
          d="M52.3926 17.5646C53.7323 16.984 54.7371 15.9195 54.7371 13.8872C54.7371 11.4195 52.6797 9.87109 49.5218 9.87109H41.5314C41.4357 9.87109 41.3878 9.96787 41.3878 10.0163V25.6937C41.3878 25.7904 41.4835 25.8388 41.5314 25.8388H49.5696C53.4452 25.8388 55.407 24.1937 55.407 21.484C55.4548 19.5001 54.3065 18.1453 52.3926 17.5646ZM45.0242 12.8227H48.8998C50.2873 12.8227 51.0529 13.5485 51.0529 14.5646C51.0529 15.7259 50.2873 16.4034 48.8998 16.4034H45.0242V12.8227ZM49.3782 23.0324H45.0242V19.0163H49.3782C50.9093 19.0163 51.7706 19.7421 51.7706 21.0485C51.7706 22.1614 50.9572 23.0324 49.3782 23.0324Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask2_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask2_30479_10282)">
        <path
          d="M103.684 9.58008C98.8995 9.58008 95.2153 13.1607 95.2153 17.951C95.2153 22.7414 98.8995 26.322 103.684 26.322C108.469 26.322 112.153 22.7414 112.153 17.951C112.153 13.1607 108.469 9.58008 103.684 9.58008ZM103.684 23.1285C100.766 23.1285 98.8517 20.951 98.8517 17.951C98.8517 14.9994 100.766 12.7736 103.684 12.7736C106.603 12.7736 108.517 14.9994 108.517 17.951C108.517 20.9027 106.555 23.1285 103.684 23.1285Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask3_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask3_30479_10282)">
        <path
          d="M117.464 9.91797H115.598C115.503 9.91797 115.455 10.0147 115.455 10.0631V25.7405C115.455 25.8373 115.55 25.8857 115.598 25.8857H118.9C118.995 25.8857 119.043 25.7889 119.043 25.7405V11.5631C119.091 10.6438 118.373 9.91797 117.464 9.91797Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask4_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask4_30479_10282)">
        <path
          d="M128.564 9.91797H126.746C126.65 9.91797 126.603 10.0147 126.603 10.0631V16.4018H120.526C120.526 18.0954 121.866 19.4502 123.54 19.4502H126.555V25.7405C126.555 25.8373 126.65 25.8857 126.698 25.8857H130C130.095 25.8857 130.143 25.7889 130.143 25.7405V11.5631C130.191 10.6438 129.473 9.91797 128.564 9.91797Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask5_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask5_30479_10282)">
        <path
          d="M90.2391 9.91797H82.2487H82.2008C81.531 9.91797 80.909 10.4018 80.7176 11.0309L76.0764 25.7889C76.0764 25.7889 76.0764 25.7889 76.0764 25.8373C76.0764 25.8857 76.1243 25.9341 76.1721 25.9341H78.6123C79.33 25.9341 79.952 25.4502 80.1434 24.7728L83.7798 13.0631H88.1817V25.7406C88.1817 25.8373 88.2774 25.8857 88.3252 25.8857H91.6267C91.7223 25.8857 91.7702 25.7889 91.7702 25.7406V11.5631C91.9137 10.6438 91.1482 9.91797 90.2391 9.91797Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask6_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask6_30479_10282)">
        <path
          d="M73.3497 9.91797H70.1918C70.0961 9.91797 70.0482 9.96636 70.0004 10.0147L62.5363 20.418V11.5631C62.5363 10.6438 61.8186 9.91797 60.9095 9.91797H59.0913C58.9956 9.91797 58.9478 10.0147 58.9478 10.0631V25.7405C58.9478 25.8373 59.0434 25.8857 59.0913 25.8857H62.2013C62.297 25.8857 62.3449 25.8373 62.3927 25.7889L69.8568 15.4341V25.7405C69.8568 25.8373 69.9525 25.8857 70.0004 25.8857H73.3018C73.3975 25.8857 73.4454 25.7889 73.4454 25.7405V10.0631C73.4932 9.96636 73.4454 9.91797 73.3497 9.91797Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask7_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask7_30479_10282)">
        <path
          d="M33.3493 17.5147L38.1819 10.1115V10.0631C38.1819 10.0147 38.134 9.96636 38.0862 9.96636H34.4498C34.4019 9.96636 34.3541 10.0147 34.3063 10.0631L30.1436 16.3535H27.7034V11.5631C27.7034 10.6438 26.9857 9.91797 26.0766 9.91797H24.2584C24.1627 9.91797 24.1149 10.0147 24.1149 10.0631V25.7406C24.1149 25.8373 24.2106 25.8857 24.2584 25.8857H27.5598C27.6555 25.8857 27.7034 25.7889 27.7034 25.7406V19.2567H30.4785L34.689 25.8373C34.7369 25.8857 34.7847 25.9341 34.8326 25.9341H38.4689C38.5168 25.9341 38.5646 25.8857 38.5646 25.8373V25.7889L33.3493 17.5147Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask8_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask8_30479_10282)">
        <path
          d="M130.192 4.83871C132.823 4.83871 134.976 2.66129 134.976 0H135.168C135.168 2.66129 137.321 4.83871 139.952 4.83871V5.03226C137.321 5.03226 135.168 7.20968 135.168 9.87097H134.976C134.976 7.20968 132.823 5.03226 130.192 5.03226V4.83871Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask9_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask9_30479_10282)">
        <path
          d="M16.2199 34.8867C16.794 34.8867 17.2725 35.0803 17.6074 35.419C17.9423 35.7577 18.1337 36.2416 18.1337 36.8222C18.1337 37.4028 17.9423 37.8867 17.6074 38.2254C17.2725 38.5641 16.794 38.7093 16.2199 38.7093H14.7844V40.4512C14.7844 40.548 14.7844 40.6448 14.7366 40.6448C14.6887 40.6932 14.6409 40.6932 14.4974 40.6932H14.0189C13.9232 40.6932 13.8275 40.6932 13.7797 40.6448C13.7318 40.5964 13.7318 40.548 13.7318 40.4512V35.177C13.7318 35.0803 13.7318 34.9835 13.7797 34.9835C13.8275 34.9351 13.8754 34.9351 14.0189 34.9351L16.2199 34.8867ZM16.1242 37.7416C16.4112 37.7416 16.6505 37.6448 16.8419 37.4996C16.9854 37.3545 17.0811 37.1125 17.0811 36.8222C17.0811 36.5319 16.9854 36.2899 16.8419 36.1448C16.6983 35.9996 16.4591 35.9028 16.1242 35.9028H14.7844V37.7416H16.1242Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask10_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask10_30479_10282)">
        <path
          d="M23.4932 40.4527C23.541 40.6463 23.4932 40.7431 23.3018 40.7431H22.8712C22.6798 40.7431 22.5841 40.7431 22.5363 40.6947C22.4884 40.6463 22.4406 40.5979 22.3927 40.5011L22.0099 39.4366H19.7611L19.3784 40.5011C19.3305 40.5979 19.2827 40.6463 19.2348 40.6947C19.187 40.7431 19.0434 40.7431 18.8999 40.7431H18.5171C18.3257 40.7431 18.2779 40.6463 18.3257 40.4527L20.3831 35.0818C20.431 34.985 20.4788 34.9366 20.5267 34.8882C20.5745 34.8398 20.6224 34.8398 20.7659 34.8398H21.1965C21.2922 34.8398 21.3879 34.8398 21.4358 34.8882C21.4836 34.9366 21.5315 34.985 21.5793 35.0818L23.4932 40.4527ZM21.1008 36.8721C21.053 36.7269 21.0052 36.5818 20.9573 36.3882C20.9095 36.2431 20.9095 36.0979 20.9095 36.0011V35.856H20.8616C20.8616 36.1463 20.8138 36.485 20.6702 36.8721L20.0482 38.614H21.7229L21.1008 36.8721Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask11_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask11_30479_10282)">
        <path
          d="M28.1338 36.4351C28.1338 37.0158 27.8945 37.4512 27.4639 37.6932C28.0381 37.9351 28.2773 38.419 28.2773 39.0964C28.2773 39.6287 28.0859 40.0641 27.751 40.4028C27.4161 40.6932 26.8419 40.8867 26.1242 40.8867C24.8323 40.8867 24.0189 40.4028 23.684 39.4835C23.6362 39.2899 23.684 39.1932 23.8754 39.1448L24.306 38.9996C24.4017 38.9512 24.4974 38.9512 24.5452 38.9996C24.5931 39.048 24.6409 39.0964 24.6888 39.1932C24.7845 39.4351 24.928 39.6287 25.1673 39.7738C25.4065 39.919 25.7414 39.9674 26.172 39.9674C26.8897 39.9674 27.2247 39.677 27.2247 39.1448C27.2247 38.9028 27.1768 38.6609 27.0333 38.5158C26.8897 38.3706 26.6984 38.2738 26.4591 38.2738H25.3108C25.2151 38.2738 25.1194 38.2738 25.0716 38.2254C25.0237 38.177 25.0237 38.1287 25.0237 38.0319V37.6448C25.0237 37.548 25.0237 37.4512 25.0716 37.4029C25.1194 37.3545 25.1673 37.3545 25.3108 37.3545H26.3156C26.5548 37.3545 26.7462 37.3061 26.8897 37.1609C27.0333 37.0158 27.0811 36.8222 27.0811 36.5803C27.0811 36.048 26.7462 35.7577 26.0763 35.7577C25.6936 35.7577 25.3586 35.8061 25.1673 35.9512C24.9759 36.048 24.8323 36.2416 24.7366 36.5319C24.6888 36.6287 24.6409 36.677 24.5931 36.7254C24.5453 36.7738 24.4496 36.7254 24.3539 36.7254L23.9232 36.5803C23.7319 36.5319 23.684 36.3867 23.7319 36.2416C24.0668 35.3222 24.8323 34.8867 26.1242 34.8867C26.7462 34.8867 27.2247 35.0319 27.5596 35.3222C27.9902 35.5158 28.1338 35.9029 28.1338 36.4351Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask12_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask12_30479_10282)">
        <path
          d="M33.3018 34.8882C33.4932 34.8882 33.4932 34.985 33.4453 35.1786L31.0051 40.5011C30.9573 40.5979 30.9094 40.6947 30.8616 40.6947C30.8137 40.6947 30.7181 40.7431 30.5745 40.7431H30.0003C29.809 40.7431 29.7611 40.6463 29.8568 40.4527L30.5745 39.0011L28.6128 35.1302C28.5171 34.9366 28.5649 34.8398 28.7563 34.8398H29.2348C29.3783 34.8398 29.474 34.8398 29.5219 34.8398C29.5697 34.8398 29.6176 34.8882 29.6654 34.8882C29.7133 34.9366 29.7611 34.985 29.809 35.0818L31.1487 37.7915L32.3927 35.0818C32.4405 34.985 32.4884 34.8882 32.5362 34.8882C32.5841 34.8398 32.7276 34.8398 32.8712 34.8398H33.3018V34.8882Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask13_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask13_30479_10282)">
        <path
          d="M39.1866 34.8867C39.2823 34.8867 39.378 34.8867 39.4259 34.9351C39.4737 34.9835 39.4737 35.0319 39.4737 35.1287V40.4028C39.4737 40.4996 39.4737 40.5964 39.4259 40.6448C39.378 40.6932 39.3302 40.6932 39.1866 40.6932H38.756C38.6603 40.6932 38.5646 40.6932 38.5646 40.6448C38.5646 40.5964 38.5168 40.548 38.5168 40.4028V37.8867C38.5168 37.4028 38.5646 36.8706 38.7082 36.2416H38.6603C38.5168 36.7254 38.2775 37.2093 37.9905 37.7416L37.1771 39.1448C37.0814 39.2899 36.9857 39.3383 36.8421 39.3383H36.6029C36.5072 39.3383 36.4594 39.3383 36.4115 39.2899C36.3637 39.2416 36.3158 39.1932 36.268 39.1448L35.4546 37.6932C35.2153 37.2577 34.9761 36.7738 34.8326 36.1932H34.7847C34.8804 36.7738 34.9761 37.3061 34.9761 37.8383V40.3545C34.9761 40.4512 34.9761 40.548 34.9283 40.5964C34.8804 40.6448 34.8326 40.6448 34.7369 40.6448H34.3541C34.2584 40.6448 34.1627 40.6448 34.1149 40.5964C33.9713 40.6448 33.9713 40.548 33.9713 40.4512V35.177C33.9713 35.0803 33.9713 34.9835 34.0192 34.9835C34.067 34.9351 34.1149 34.9351 34.2584 34.9351H34.5933C34.689 34.9351 34.7847 34.9351 34.8326 34.9835C34.8804 35.0319 34.9283 35.0803 34.9761 35.177L36.6507 38.2254L38.3254 35.177C38.3732 35.0803 38.4211 35.0319 38.4689 34.9835C38.5168 34.9351 38.6125 34.9351 38.7082 34.9351L39.1866 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask14_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask14_30479_10282)">
        <path
          d="M44.6412 34.8867C44.7369 34.8867 44.8326 34.8867 44.8804 34.9351C44.9283 34.9835 44.9283 35.0319 44.9283 35.1287V40.4028C44.9283 40.4996 44.9283 40.5964 44.8804 40.6448C44.8326 40.6932 44.7847 40.6932 44.6412 40.6932H44.1627C44.067 40.6932 43.9713 40.6932 43.9235 40.6448C43.8756 40.5964 43.8756 40.548 43.8756 40.4028V38.2254H41.4833V40.4028C41.4833 40.4996 41.4833 40.5964 41.4354 40.6448C41.3876 40.6932 41.3398 40.6932 41.1962 40.6932H40.7177C40.6221 40.6932 40.5264 40.6932 40.4785 40.6448C40.4307 40.5964 40.4307 40.548 40.4307 40.4028V35.177C40.4307 35.0803 40.4307 34.9835 40.4785 34.9835C40.5264 34.9351 40.5742 34.9351 40.7177 34.9351H41.1962C41.2919 34.9351 41.3876 34.9351 41.4354 34.9835C41.4833 35.0319 41.4833 35.0803 41.4833 35.177V37.3061H43.8756V35.177C43.8756 35.0803 43.8756 34.9835 43.9235 34.9835C43.9713 34.9351 44.0192 34.9351 44.1627 34.9351C44.1627 34.8867 44.6412 34.8867 44.6412 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask15_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask15_30479_10282)">
        <path
          d="M46.2203 40.742C46.1246 40.742 46.0289 40.742 45.9811 40.6936C45.9332 40.6452 45.9332 40.5485 45.9332 40.4517V35.1775C45.9332 35.0807 45.9332 34.9839 45.9811 34.9839C46.0289 34.9355 46.0768 34.9355 46.2203 34.9355H46.6988C46.7945 34.9355 46.8902 34.9355 46.938 34.9839C46.9859 35.0323 46.9859 35.0807 46.9859 35.1775V36.9194H48.4213C48.9954 36.9194 49.4739 37.0646 49.8088 37.4033C50.1438 37.742 50.3351 38.2259 50.3351 38.8065C50.3351 39.3872 50.1438 39.871 49.8088 40.2097C49.4739 40.5485 48.9954 40.742 48.4213 40.742H46.2203ZM46.938 37.8872V39.7743H48.2777C48.5648 39.7743 48.804 39.6775 48.9954 39.5323C49.139 39.3872 49.2347 39.1452 49.2347 38.8549C49.2347 38.5646 49.139 38.3226 48.9954 38.1775C48.8519 38.0323 48.6127 37.9355 48.2777 37.9355L46.938 37.8872ZM51.1485 35.1775C51.1485 35.0807 51.1485 34.9839 51.1964 34.9839C51.2442 34.9355 51.2921 34.9355 51.4356 34.9355H51.9141C52.0098 34.9355 52.1055 34.9355 52.1533 34.9839C52.2012 35.0323 52.2012 35.0807 52.2012 35.1775V40.4517C52.2012 40.5485 52.2012 40.6452 52.1533 40.6936C52.1055 40.742 52.0576 40.742 51.9141 40.742H51.4356C51.3399 40.742 51.2442 40.742 51.1964 40.6936C51.1485 40.6452 51.1485 40.5968 51.1485 40.4517V35.1775Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask16_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask16_30479_10282)">
        <path
          d="M57.4643 34.8868C57.56 34.8868 57.6557 34.8868 57.7035 34.9352C57.7514 34.9836 57.7514 35.032 57.7514 35.1287V40.4029C57.7514 40.4997 57.7514 40.5965 57.7035 40.6449C57.6557 40.6933 57.6078 40.6933 57.4643 40.6933H56.9858C56.8901 40.6933 56.7944 40.6933 56.7466 40.6449C56.6987 40.5965 56.6987 40.5481 56.6987 40.4029V37.9836C56.6987 37.5481 56.6987 37.2578 56.7466 37.0158C56.7944 36.7739 56.8423 36.4836 56.8901 36.0965H56.8423C56.6509 36.5803 56.3638 37.1126 56.0289 37.6449L54.1629 40.4997C54.115 40.5965 54.0193 40.6449 53.8758 40.6449H53.3973C53.3016 40.6449 53.2059 40.6449 53.1581 40.5965C53.1102 40.5481 53.1102 40.4997 53.1102 40.3545V35.1771C53.1102 35.0803 53.1102 34.9836 53.1581 34.9836C53.2059 34.9352 53.2538 34.9352 53.3973 34.9352H53.8758C53.9715 34.9352 54.0672 34.9352 54.115 34.9836C54.1629 35.032 54.1629 35.0803 54.1629 35.1771V37.5481C54.1629 37.9836 54.1629 38.2739 54.115 38.5158C54.0672 38.7578 54.0193 39.0481 53.9715 39.4352H54.0193C54.2107 38.9029 54.4978 38.3707 54.8806 37.79L56.6987 34.9836C56.7466 34.8868 56.8423 34.8384 56.9858 34.8384L57.4643 34.8868ZM56.8901 33.6287C56.7944 33.9191 56.6031 34.1126 56.3638 34.2578C56.1246 34.4029 55.8375 34.4997 55.4547 34.4997C55.1198 34.4997 54.8327 34.4029 54.5456 34.2578C54.3064 34.1126 54.115 33.8707 54.0193 33.6287C53.9715 33.532 54.0193 33.4352 54.1629 33.3868L54.4978 33.2416C54.6413 33.1933 54.737 33.2416 54.7849 33.3384C54.8806 33.6287 55.1198 33.7739 55.4069 33.7739C55.7418 33.7739 55.9332 33.6287 56.0289 33.3384C56.0767 33.2416 56.1724 33.1933 56.2681 33.2416L56.6987 33.3868C56.7466 33.4352 56.7944 33.4352 56.8423 33.4836C56.938 33.4836 56.938 33.532 56.8901 33.6287Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask17_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask17_30479_10282)">
        <path
          d="M64.9764 34.8867C65.072 34.8867 65.1677 34.8867 65.2156 34.9351C65.2634 34.9835 65.2634 35.0319 65.2634 35.1287V39.7254H65.6941C65.7898 39.7254 65.8854 39.7254 65.8854 39.7738C65.8854 39.8222 65.9333 39.8706 65.9333 40.0157V41.6609C65.9333 41.7577 65.9333 41.8545 65.8854 41.8545C65.8376 41.8545 65.7898 41.9028 65.6941 41.9028H65.2634C65.1677 41.9028 65.072 41.9028 65.0242 41.8545C64.9764 41.8061 64.9764 41.7577 64.9764 41.6609V40.6932H61.2443V41.6609C61.2443 41.7577 61.2443 41.8545 61.1965 41.8545C61.1486 41.9028 61.1008 41.9028 61.0051 41.9028H60.5744C60.4787 41.9028 60.3831 41.9028 60.3831 41.8545C60.3831 41.8061 60.3352 41.7577 60.3352 41.6609V40.0157C60.3352 39.919 60.3352 39.8222 60.3831 39.7738C60.4309 39.7254 60.4787 39.7254 60.5744 39.7254H60.7658C60.8615 39.677 60.9572 39.5803 61.0529 39.4835C61.1486 39.3867 61.1965 39.2416 61.2921 38.9996C61.3878 38.8061 61.4357 38.5158 61.4835 38.1287C61.5314 37.7416 61.5314 37.3061 61.5314 36.8222V35.1287C61.5314 35.0319 61.5314 34.9351 61.5792 34.9351C61.6271 34.8867 61.6749 34.8867 61.8185 34.8867H64.9764ZM62.4405 35.8545V36.8706C62.4405 38.2254 62.2491 39.1932 61.9142 39.7738H64.2587V35.8545H62.4405Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask18_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask18_30479_10282)">
        <path
          d="M70.2393 34.8867C70.335 34.8867 70.4307 34.8867 70.4785 34.9351C70.5264 34.9835 70.5264 35.0319 70.5264 35.1287V35.5158C70.5264 35.6125 70.5264 35.7093 70.4785 35.7093C70.4307 35.7093 70.3828 35.7577 70.2393 35.7577H67.7512V37.2093H69.8565C69.9522 37.2093 70.0479 37.2093 70.0479 37.2577C70.0479 37.3061 70.0957 37.3545 70.0957 37.4996V37.8867C70.0957 37.9835 70.0957 38.0803 70.0479 38.1287C70 38.177 69.9522 38.177 69.8565 38.177H67.7512V39.677H70.335C70.4307 39.677 70.5264 39.677 70.5742 39.7254C70.6221 39.7738 70.6221 39.8222 70.6221 39.9674V40.3545C70.6221 40.4512 70.6221 40.548 70.5742 40.5964C70.5264 40.6448 70.4785 40.6448 70.335 40.6448H66.9857C66.89 40.6448 66.7943 40.6448 66.7465 40.5964C66.6986 40.548 66.6986 40.4996 66.6986 40.3545V35.177C66.6986 35.0803 66.6986 34.9835 66.7465 34.9835C66.7943 34.9351 66.8422 34.9351 66.9857 34.9351C66.9857 34.8867 70.2393 34.8867 70.2393 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask19_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask19_30479_10282)">
        <path
          d="M74.0195 34.8867C74.5458 34.8867 74.9765 35.0319 75.2636 35.2738C75.5506 35.5641 75.6942 35.9028 75.6942 36.4351C75.6942 37.0158 75.5028 37.4512 75.0722 37.6932V37.7416C75.6463 37.9351 75.8856 38.419 75.8856 39.1448C75.8856 39.6287 75.6942 40.0641 75.3592 40.3061C75.0243 40.5964 74.5937 40.7416 74.0195 40.7416H71.7707C71.675 40.7416 71.5793 40.7416 71.5315 40.6932C71.4836 40.6448 71.4836 40.5964 71.4836 40.4512V35.177C71.4836 35.0803 71.4836 34.9835 71.5315 34.9351C71.5793 34.8867 71.6272 34.8867 71.7707 34.8867H74.0195ZM74.6415 36.5803C74.6415 36.0964 74.4023 35.8545 73.876 35.8545H72.4884V37.3061H73.876C74.4023 37.3061 74.6415 37.0641 74.6415 36.5803ZM74.7851 38.9996C74.7851 38.4674 74.5458 38.2254 74.0195 38.2254H72.4884V39.7738H74.0195C74.5458 39.7738 74.7851 39.5319 74.7851 38.9996Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask20_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask20_30479_10282)">
        <path
          d="M80.2874 34.8867C80.3831 34.8867 80.4788 34.8867 80.5266 34.9351C80.5745 34.9835 80.5745 35.0319 80.5745 35.1287V35.5158C80.5745 35.6125 80.5745 35.7093 80.5266 35.7093C80.4788 35.7093 80.4309 35.7577 80.2874 35.7577H77.7993V37.2093H79.9046C80.0003 37.2093 80.096 37.2093 80.1438 37.2577C80.1917 37.3061 80.1917 37.3545 80.1917 37.4996V37.8867C80.1917 37.9835 80.1917 38.0803 80.1438 38.1287C80.096 38.177 80.0481 38.177 79.9046 38.177H77.7993V39.677H80.3831C80.4788 39.677 80.5745 39.677 80.6223 39.7254C80.6702 39.7738 80.6702 39.8222 80.6702 39.9674V40.3545C80.6702 40.4512 80.6702 40.548 80.6223 40.5964C80.5745 40.6448 80.5266 40.6448 80.3831 40.6448H77.0816C76.9859 40.6448 76.8903 40.6448 76.8424 40.5964C76.7946 40.548 76.7946 40.4996 76.7946 40.3545V35.177C76.7946 35.0803 76.7946 34.9835 76.8424 34.9835C76.8903 34.9351 76.9381 34.9351 77.0816 34.9351C77.0816 34.8867 80.2874 34.8867 80.2874 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask21_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask21_30479_10282)">
        <path
          d="M85.6459 34.8867C85.7416 34.8867 85.8373 34.8867 85.8373 34.9351C85.8851 34.9835 85.8851 35.0319 85.8851 35.1287V40.4028C85.8851 40.4996 85.8851 40.5964 85.8373 40.6448C85.7894 40.6932 85.7416 40.6932 85.6459 40.6932H85.1674C85.0717 40.6932 84.976 40.6932 84.9282 40.6448C84.8804 40.5964 84.8803 40.548 84.8803 40.4028V35.8061H83.1579V36.8706C83.1579 37.4512 83.11 37.9351 83.0622 38.3706C83.0143 38.8061 82.9186 39.1448 82.8229 39.3867C82.7272 39.6287 82.6315 39.8706 82.488 40.0641C82.3445 40.2577 82.2009 40.4028 82.0574 40.4996C81.9138 40.5964 81.7703 40.6932 81.5789 40.7899C81.4832 40.8383 81.4354 40.8383 81.3397 40.8383C81.2918 40.8383 81.244 40.7416 81.1961 40.6932L81.0048 40.2577C80.9091 40.0641 80.9569 39.9674 81.1483 39.8706C81.244 39.8222 81.3397 39.7738 81.4354 39.7254C81.4832 39.677 81.5789 39.5803 81.6746 39.4351C81.7703 39.2899 81.866 39.1448 81.9138 38.9512C81.9617 38.7577 82.0095 38.4674 82.0574 38.1287C82.1052 37.7899 82.1052 37.3545 82.1052 36.919V35.177C82.1052 35.0803 82.1052 34.9835 82.1531 34.9835C82.2009 34.9351 82.2488 34.9351 82.3923 34.9351C82.4402 34.8867 85.6459 34.8867 85.6459 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask22_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask22_30479_10282)">
        <path
          d="M86.9377 36.9196C86.9377 36.2422 87.1291 35.7099 87.5598 35.3228C87.9425 34.9357 88.5167 34.7422 89.2822 34.7422C89.9999 34.7422 90.5741 34.9357 91.0047 35.3228C91.3875 35.7099 91.6267 36.2422 91.6267 36.9196V38.7099C91.6267 39.3873 91.4354 39.9196 91.0047 40.3067C90.622 40.6938 90.0478 40.8873 89.2822 40.8873C88.5167 40.8873 87.9425 40.6938 87.5598 40.3067C87.177 39.9196 86.9377 39.3873 86.9377 38.7099V36.9196ZM90.5263 36.9196C90.5263 36.5325 90.4306 36.2422 90.1913 36.0486C89.9521 35.8551 89.665 35.7583 89.2344 35.7583C88.8038 35.7583 88.5167 35.8551 88.2775 36.0486C88.0382 36.2422 87.9425 36.5325 87.9425 36.9196V38.7099C87.9425 39.097 88.0382 39.3873 88.2775 39.5809C88.5167 39.7744 88.8038 39.8712 89.2344 39.8712C89.665 39.8712 89.9521 39.7744 90.1913 39.5809C90.4306 39.3873 90.5263 39.097 90.5263 38.7099V36.9196Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask23_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask23_30479_10282)">
        <path
          d="M96.6982 34.8867C96.7939 34.8867 96.8896 34.8867 96.8896 34.9351C96.9374 34.9835 96.9374 35.0319 96.9374 35.1287V40.4028C96.9374 40.4996 96.9374 40.5964 96.8896 40.6448C96.8417 40.6932 96.7939 40.6932 96.6982 40.6932H96.2197C96.124 40.6932 96.0283 40.6932 96.0283 40.6448C96.0283 40.5964 95.9805 40.548 95.9805 40.4028V35.8061H93.636V40.4028C93.636 40.4996 93.636 40.5964 93.5882 40.6448C93.5403 40.6932 93.4925 40.6932 93.3968 40.6932H92.9183C92.8226 40.6932 92.7269 40.6932 92.6791 40.6448C92.6312 40.5964 92.6312 40.548 92.6312 40.4028V35.177C92.6312 35.0803 92.6312 34.9835 92.6791 34.9835C92.7269 34.9351 92.7748 34.9351 92.9183 34.9351C92.8705 34.8867 96.6982 34.8867 96.6982 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask24_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask24_30479_10282)">
        <path
          d="M103.349 34.8867C103.445 34.8867 103.541 34.8867 103.541 34.9351C103.588 34.9835 103.588 35.0319 103.588 35.1287V40.4028C103.588 40.4996 103.588 40.5964 103.541 40.6448C103.493 40.6932 103.445 40.6932 103.349 40.6932H102.919C102.823 40.6932 102.727 40.6932 102.679 40.6448C102.632 40.5964 102.632 40.548 102.632 40.4028V37.8867C102.632 37.4028 102.679 36.8706 102.823 36.2416H102.775C102.632 36.7254 102.392 37.2093 102.105 37.7416L101.292 39.1448C101.196 39.2899 101.1 39.3383 100.957 39.3383H100.718C100.622 39.3383 100.574 39.3383 100.526 39.2899C100.478 39.2416 100.431 39.1932 100.383 39.1448L99.5693 37.6932C99.3301 37.2577 99.0909 36.7738 98.9473 36.1932H98.8995C98.9952 36.7738 99.0909 37.3061 99.0909 37.8383V40.3545C99.0909 40.4512 99.0909 40.548 99.043 40.5964C98.9952 40.6448 98.9473 40.6448 98.8516 40.6448H98.4688C98.3732 40.6448 98.2775 40.6448 98.2296 40.5964C98.1818 40.548 98.1818 40.4996 98.1818 40.3545V35.177C98.1818 35.0803 98.1818 34.9835 98.2296 34.9835C98.2775 34.9351 98.3253 34.9351 98.4688 34.9351H98.8038C98.8995 34.9351 98.9952 34.9351 99.043 34.9835C99.0909 35.0319 99.1387 35.0803 99.1866 35.177L100.861 38.2254L102.536 35.177C102.584 35.0803 102.632 35.0319 102.679 34.9835C102.727 34.9351 102.823 34.9351 102.919 34.9351L103.349 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask25_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask25_30479_10282)">
        <path
          d="M108.326 34.8867C108.421 34.8867 108.517 34.8867 108.565 34.9351C108.613 34.9835 108.613 35.0319 108.613 35.1287V35.5158C108.613 35.6125 108.613 35.7093 108.565 35.7093C108.517 35.7577 108.469 35.7577 108.326 35.7577H105.838V37.2093H107.943C108.039 37.2093 108.134 37.2093 108.134 37.2577C108.134 37.3061 108.182 37.3545 108.182 37.4996V37.8867C108.182 37.9835 108.182 38.0803 108.134 38.1287C108.086 38.177 108.039 38.177 107.943 38.177H105.838V39.677H108.421C108.517 39.677 108.613 39.677 108.661 39.7254C108.708 39.7738 108.708 39.8222 108.708 39.9674V40.3545C108.708 40.4512 108.708 40.548 108.661 40.5964C108.613 40.6448 108.565 40.6448 108.421 40.6448H105.12C105.024 40.6448 104.929 40.6448 104.881 40.5964C104.833 40.548 104.833 40.4996 104.833 40.3545V35.177C104.833 35.0803 104.833 34.9835 104.881 34.9835C104.929 34.9351 104.976 34.9351 105.12 34.9351C105.072 34.8867 108.326 34.8867 108.326 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask26_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask26_30479_10282)">
        <path
          d="M113.732 34.8867C113.828 34.8867 113.923 34.8867 113.971 34.9351C114.019 34.9835 114.019 35.0319 114.019 35.1287V40.4028C114.019 40.4996 114.019 40.5964 113.971 40.6448C113.923 40.6932 113.876 40.6932 113.732 40.6932H113.254C113.158 40.6932 113.062 40.6932 113.062 40.6448C113.062 40.5964 113.014 40.548 113.014 40.4028V38.2254H110.622V40.4028C110.622 40.4996 110.622 40.5964 110.574 40.6448C110.526 40.6932 110.478 40.6932 110.383 40.6932H109.904C109.809 40.6932 109.713 40.6932 109.665 40.6448C109.617 40.5964 109.617 40.548 109.617 40.4028V35.177C109.617 35.0803 109.617 34.9835 109.665 34.9835C109.713 34.9351 109.761 34.9351 109.904 34.9351H110.383C110.478 34.9351 110.574 34.9351 110.574 34.9835C110.622 35.0319 110.622 35.0803 110.622 35.177V37.3061H113.014V35.177C113.014 35.0803 113.014 34.9835 113.062 34.9835C113.11 34.9351 113.158 34.9351 113.254 34.9351C113.254 34.8867 113.732 34.8867 113.732 34.8867Z"
          fill="#8F98A1"
        />
      </g>
      <mask
        id="mask27_30479_10282"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="140"
        height="42"
      >
        <path d="M140 0H0V42H140V0Z" fill="white" />
      </mask>
      <g mask="url(#mask27_30479_10282)">
        <path
          d="M118.804 34.8867C118.899 34.8867 118.995 34.8867 118.995 34.9351C119.043 34.9835 119.043 35.0319 119.043 35.1287V35.5158C119.043 35.6125 119.043 35.7093 118.995 35.7093C118.947 35.7093 118.899 35.7577 118.804 35.7577H117.416V40.3545C117.416 40.4512 117.416 40.548 117.368 40.5964C117.32 40.6448 117.272 40.6448 117.129 40.6448H116.65C116.555 40.6448 116.459 40.6448 116.411 40.5964C116.363 40.548 116.363 40.4996 116.363 40.3545V35.7577H114.976C114.88 35.7577 114.784 35.7577 114.784 35.7093C114.784 35.6609 114.737 35.6125 114.737 35.5158V35.1287C114.737 35.0319 114.737 34.9351 114.784 34.9351C114.832 34.8867 114.88 34.8867 114.976 34.8867H118.804Z"
          fill="#8F98A1"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_30479_10282">
        <rect width="140" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default AkvilonGrayLogo
